import ErrorBox from '../error-box';
import Confirm from '../confirm';
import { useStore } from '../../lib/hooks/useStore';
import style from './style.module.scss';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

interface AccountNotFoundProps {
	confirmProps?: {
		previousPageTarget: string;
		yesButtonLabel: string;
		noButtonLabel: string;
		questionLabel?: string;
		yesCallback?: () => void;
		noCallback?: () => void;
	};
}

const AccountNotFound = observer(function ({ confirmProps }: AccountNotFoundProps) {
	const {
		configStore: { getString },
		uiStore: { setBackEnabled, isBackEnabled },
	} = useStore();
	const [wasBackEnabled] = useState(isBackEnabled);

	useEffect(() => {
		setBackEnabled(false);
		return () => {
			setBackEnabled(wasBackEnabled);
		};
	}, [setBackEnabled, wasBackEnabled]);

	return (
		<div className={style.error}>
			<ErrorBox>{getString('account-not-found')}</ErrorBox>
			{confirmProps && (
				<Confirm
					questionLabel={getString(confirmProps.questionLabel ?? 'try-again-message')}
					className={style.error__confirm}
					yesButton={{ label: confirmProps.yesButtonLabel ?? 'yes', value: 'yes', target: confirmProps.previousPageTarget }}
					yesCallback={confirmProps.yesCallback}
					noButton={{
						label: confirmProps.noButtonLabel ?? 'no',
						value: 'no',
					}}
					noCallback={confirmProps.noCallback}
				/>
			)}
		</div>
	);
});

export default AccountNotFound;
